export default __webpack_public_path__ + "static/media/sequelize.f874343b.png";